import { JSX } from "react";
import ArrowIcon from "./Components/ArrowIcon";
import InfrastructureHero from "./Components/InfrastructureHero";
import InfrastructureNavCards from "./Components/InfrastructureNavCards";
import InfrastructureSection from "./Components/InfrastructureSection";
import useScrollToHash from "./Components/useScrollToHash";


/* ---------------------- Navigation Cards ---------------------- */
const strategyCards = [
    { id: "moip", title: "MOIP" },
    { id: "infrastructureinnovationpractices", title: "Infrastructure innovation practices" },
    { id: "infrastructurethrusts", title: "Infrastructure Thrust" },
    { id: "infrastructuregovernance", title: "Infrastructure governance" },
];

/* ---------------------- Reusable Section ---------------------- */
type Section = {
    id: string;
    tag: string;
    title: string;
    sideImage?: string;
    description?: JSX.Element;
    variant?: "gray" | "white";
    content: JSX.Element;
};

const sections: Section[] = [
    {
        id: "moip",
        tag: "WCIF 2050",
        title: "MOIP: Mission elements to rely upon",
        description: (
            <>
                MOIP stands for <strong>Mission Oriented Innovation Policies</strong>
            </>
        ),
        sideImage: "media/images/darkwcif.png",
        content: (
            <ul>
                <li>Be bold, inspirational across society</li>
                <li>Ambitious using research innovation action</li>
                <li>Offer clear directions, targets & measures</li>
                <li>
                    Ensure multi or cross-disciplinarity to drive innovation across sectors
                </li>
                <li>Seek out and support multiple bottom-up-solutions</li>
            </ul>
        ),
    },
    {
        id: "infrastructureinnovationpractices",
        tag: "WCIF 2050",
        title: "Infrastructure innovation practices:",
        variant: "gray",
        content: (
            <ul>
                <li>
                    For simple and complicated contexts <ArrowIcon /> Good and Best practices
                    work best respectively
                </li>
                <li>
                    For complex and chaotic contexts <ArrowIcon /> Emergent and Novel practices
                    work best respectively
                </li>
            </ul>
        ),
    },
    {
        id: "infrastructurethrusts",
        tag: "WCIF 2050",
        title: "Infrastructure thrusts:",
        content: (
            <ul>
                <li>Prioritise infrastructure for maximal effect</li>
                <li>Support and build Municipal infrastructure</li>
                <li>Private sector partnerships</li>
                <li>Innovation and acritical Futures-orientation</li>
                <li>Climate change and socio-ecological imperatives</li>
            </ul>
        ),
    },
    {
        id: "infrastructuregovernance",
        tag: "WCIF 2050",
        title:
            "Infrastructure governance across life-cycle model linked to FIDPM & ISO9001:",
        variant: "gray",
        content: (
            <ul>
                <li>Initiation phase</li>
                <li>Planning phase</li>
                <li>Design phase</li>
                <li>Construction phase</li>
                <li>Operations and maintenance phase</li>
                <li>Asset end-of-life phase (repurpose and renewal)</li>
            </ul>
        ),
    },
];
/* ---------------------- Main Component ---------------------- */
const WesternCapeInfrastructureFrameWork = () => {
    useScrollToHash();

    return (
        <section className="western-cape-infrastructure-strategy-page frame-work bg-white overflow-auto">

            <InfrastructureHero
                pdf="pdfs/public-pages/2024-10-10-WCIF-2050-FINAL.pdf"
                logo="media/images/wcif2025.png"
                logoAlt="WCIF 2050"
            >
                <InfrastructureNavCards
                    cards={strategyCards}
                    baseUrl="/pages/western-cape-infrastructure-framework"
                />
            </InfrastructureHero>

            {sections.map((section) => (
                <InfrastructureSection
                    key={section.id}
                    {...section}
                />
            ))}

        </section>
    );
};
export default WesternCapeInfrastructureFrameWork;